<span [ngClass]="placeholder.className" [attr.data-before]="placeholder.items ? placeholder.items[0]?.name : ''"></span>
<span class="ph-name">{{placeholder.id}}</span>
